import useProductionTeam from "./useProductionTeam";

export default function useProductionTeamMember({ production, role, userId }) {
	const team = useProductionTeam(production);

	return team.find((member) => member.user?.id === userId && member.role === role);
}
